import { ProductHelper } from '#/global/helper/Product/ProductHelper'

export default {
    cz: {
        pricePerUnit: (unit: string) => `cena za ${ProductHelper.formatUnit(unit)} s DPH`,
        tooltip: (price: string) => `Ceníková cena ${price}`,
        tooltipLowest: (price: string, tax: string) => `Nejnižší prodejní cena v době 30 dnů před poskytnutím slevy byla ${price} s ${tax}.`,
        tooltipB2B: (price: string, priceNoVat: string, tax: string) => `Ceníková cena ${price} s ${tax} (${priceNoVat} bez ${tax})`,
    },
    sk: {
        pricePerUnit: (unit: string) => `cena za ${ProductHelper.formatUnit(unit)} s DPH`,
        tooltip: (price: string) => `Ceníková cena ${price}`,
        tooltipLowest: (price: string, tax: string) => `Najnižšia predajná cena v období 30 dní pred poskytnutím zľavy bola ${price} ${tax}.`,
        tooltipB2B: (price: string, priceNoVat: string, tax: string) => `Cenníková cena ${price} s ${tax} (${priceNoVat} bez ${tax})`,
    },
}
